import types from "./types";

const INITIAL_STATE = {
  newTemplate: null,
  creatingNewTemplate: false,
  newTemplateError: null,

  templateList: null,
  gettingTemplateList: false,
  templateListError: null,

  updateTemplate: null,
  updatingTemplate: false,
  updateTemplateError: null,

  deleteTemplate: null,
  deletingTemplate: false,
  deleteTemplateError: null,

  templateDetails: null,
  loadingTemplateDetails: false,
  templateDetailsError: null,

  mailWithPdf: null,
  sendingMailWithPdf: false,
  mailWithPdfError: null,

  copiedTemplate: null,
  copyingTemplate: false,
  duplicateTemplateError: null,
};

const reportBuilderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
		/**
		 * CASES RELATED TO DUPLICATE TEMPLATE
		 */
		case types.DUPLICATE_TEMPLATE_START: {
			return {
				...state,
				copiedTemplate: null,
				copyingTemplate: true,
				duplicateTemplateError: null,
			}
		}
		case types.DUPLICATE_TEMPLATE_SUCCESS: {
			return {
				...state,
				copiedTemplate: action.payload,
				copyingTemplate: false,
				duplicateTemplateError: null,
				templateList: {
					...state.templateList,
					data: [
						action.payload.duplicate_template,
						...state.templateList.data,
					]
				}
			}
		}
		case types.DUPLICATE_TEMPLATE_ERROR: {
			return {
				...state,
				copiedTemplate: null,
				copyingTemplate: false,
				duplicateTemplateError: action.payload,
			}
		}

		/**
		 * CASE RELATED TO MAIL WITH PDF
		 * */
		case types.SEND_MAIL_WITH_PDF_START: {
			return {
				...state,
				mailWithPdf: null,
				sendingMailWithPdf: true,
				mailWithPdfError: null,
			};
		}
		case types.SEND_MAIL_WITH_PDF_SUCCESS: {
			return {
				...state,
				mailWithPdf: action.payload,
				sendingMailWithPdf: false,
				mailWithPdfError: null,
			};
		}
		case types.SEND_MAIL_WITH_PDF_ERROR: {
			return {
				...state,
				mailWithPdf: null,
				sendingMailWithPdf: false,
				mailWithPdfError: action.payload,
			};
		}
		/**
		 * CASE RELATED TO TEMPLATE DETAILS
		 * */
		case types.TEMPLATE_DETAILS_START: {
			return {
				...state,
				templateDetails: null,
				loadingTemplateDetails: true,
				templateDetailsError: null,
			};
		}
		case types.TEMPLATE_DETAILS_SUCCESS: {
			return {
				...state,
				templateDetails: action.payload,
				loadingTemplateDetails: false,
				templateDetailsError: null,
			};
		}
		case types.TEMPLATE_DETAILS_ERROR: {
			return {
				...state,
				templateDetails: null,
				loadingTemplateDetails: false,
				templateDetailsError: action.payload,
			};
		}
		case types.CLEAR_TEMPLATE_DETAILS: {
			return {
				...state,
				templateDetails: null,
				loadingTemplateDetails: false,
				templateDetailsError: null,
			};
		}

		/**
		 * CASE RELATED TO CREATE TEMPLATE
		 * */
		case types.CREATE_TEMPLATE_START: {
			return {
				...state,
				newTemplate: null,
				creatingNewTemplate: true,
				newTemplateError: null,
			};
		}
		case types.CREATE_TEMPLATE_SUCCESS: {
			return {
				...state,
				newTemplate: action.payload,
				creatingNewTemplate: false,
				newTemplateError: null,
			};
		}
		case types.CREATE_TEMPLATE_ERROR: {
			return {
				...state,
				newTemplate: null,
				creatingNewTemplate: false,
				newTemplateError: action.payload,
			};
		}
		case types.CREATE_TEMPLATE_STATE_RESET: {
			return {
				...state,
				newTemplate: null,
				creatingNewTemplate: false,
				newTemplateError: null,
			};
		}

		/**
		 * CASE RELATED TO TEMPLATE LIST
		 * */
		case types.TEMPLATE_LIST_START: {
			return {
				...state,
				templateList: null,
				gettingTemplateList: true,
				templateListError: null,
			};
		}
		case types.TEMPLATE_LIST_SUCCESS: {
			return {
				...state,
				templateList: action.payload,
				gettingTemplateList: false,
				templateListError: null,
			};
		}
		case types.TEMPLATE_LIST_ERROR: {
			return {
				...state,
				templateList: null,
				gettingTemplateList: false,
				templateListError: action.payload,
			};
		}

		/**
		 * CASE RELATED TO UPDATE TEMPLATE
		 * */
		case types.UPDATE_TEMPLATE_START: {
			return {
				...state,
				updateTemplate: null,
				updatingTemplate: true,
				updateTemplateError: null,
			};
		}
		case types.UPDATE_TEMPLATE_SUCCESS: {
			return {
				...state,
				updateTemplate: action.payload,
				updatingTemplate: false,
				updateTemplateError: null,
			};
		}
		case types.UPDATE_TEMPLATE_ERROR: {
			return {
				...state,
				updateTemplate: null,
				updatingTemplate: false,
				updateTemplateError: action.payload,
			};
		}
		case types.UPDATE_TEMPLATE_STATE_RESET: {
			return {
				...state,
				updateTemplate: null,
				updatingTemplate: false,
				updateTemplateError: null,
			};
		}
		/**
		 * CASE RELATED TO DELETE TEMPLATE
		 * */
		case types.DELETE_TEMPLATE_START: {
			return {
				...state,
				deleteTemplate: null,
				deletingTemplate: true,
				deleteTemplateError: null,
			};
		}
		case types.DELETE_TEMPLATE_SUCCESS: {
			const list = Object.assign([], state.templateList.data);
			const index = list.findIndex((i) => i._id.$oid === action.payload._id);
			if (index > -1) list.splice(index, 1);

			return {
				...state,
				deleteTemplate: action.payload,
				deletingTemplate: false,
				deleteTemplateError: null,
				templateList: {
					...state.templateList,
					data: list,
				},
			};
		}
		case types.DELETE_TEMPLATE_ERROR: {
			return {
				...state,
				deleteTemplate: null,
				deletingTemplate: false,
				deleteTemplateError: action.payload,
			};
		}
		case types.DELETE_TEMPLATE_STATE_RESET: {
			return {
				...state,
				deleteTemplate: null,
				deletingTemplate: false,
				deleteTemplateError: null,
			};
		}

		default:
			return {
				...state,
			};
	}
};

export default reportBuilderReducer;
